import { render, staticRenderFns } from "./UpdateVariable.vue?vue&type=template&id=1123680c&scoped=true&"
import script from "./UpdateVariable.vue?vue&type=script&lang=js&"
export * from "./UpdateVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123680c",
  null
  
)

export default component.exports